import { AUTH_SESSION_KEYS } from "@/constants/auth-session-keys";

export interface OtpSession {
  email: string;
  expirationTime: number;
}

export const saveOtpSession = (session: OtpSession): void => {
  sessionStorage.setItem(AUTH_SESSION_KEYS.OTP_TOKEN, JSON.stringify(session));
};

export const readOtpSession = (): OtpSession | null => {
  const raw = sessionStorage.getItem(AUTH_SESSION_KEYS.OTP_TOKEN);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as OtpSession;
    if (!parsed?.email || !parsed?.expirationTime) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const clearOtpSession = (): void => {
  sessionStorage.removeItem(AUTH_SESSION_KEYS.OTP_TOKEN);
};
